export default {
    path: 'deal',
    component: () => import('../Deal.vue'),
    children: [
        {
            path: '',
            name: 'Danh Sách Deal',
            component: () => import('../table/Table.vue')
        },
    ]
};